import VaultExperienceBase from './vault-experience-base'
import { WalletContact } from '@/state/vault/domain'
import MajblommanWallet from './rooms/majblomman-wallet/majblomman-wallet'
import { WalletFaceParser } from '@/shared/di/interface/walletfaces'

export default class VaultExperienceMajblomman extends VaultExperienceBase {
  walletFaceId = WalletFaceParser.Majblomman
  startRoom = ''
  async init(walletFaceId: string) {
    await super.init(walletFaceId)

    this.swapWalletFace(walletFaceId)
  }

  swapWalletFace(walletFaceId: string): Promise<void> {
    const majblommanWallet = new MajblommanWallet()
    return this.loadWalletFace(walletFaceId, [majblommanWallet])
  }

  showContactWallet(contact: WalletContact | undefined): Promise<void> {
    /*const walletRoom = this.getRoomManager(this.defaultRoom.config.id) as StudioWallet
    if (walletRoom) {
      walletRoom.physics.interactions.setActiveUserAvailable(false)

      if (contact) {
        //contact.uxPub.walletFaceId = DEFAULT_WALLET_FACE_ID
        return walletRoom.walletManager.showContactWallet(contact)
      } else {
        walletRoom.walletManager.hideActiveWallet()
      }

      //this.#bloomListIsDirty = true
    }
*/
    return Promise.resolve()
  }

  showTjingTube(): Promise<void> {
    return Promise.resolve()
  }

  updateTube(contacts: WalletContact) {}

  updateTubeCoins() {}

  onTokenEnteredTubeHandler = (data: any) => {}
}
